export enum Direction {
    LEFT,
    RIGHT,
    UP,
    DOWN,
    NONE
}



// WEBPACK FOOTER //
// ./src/app/common-types/direction.ts